// Persistent Help button for small screens where navbar collapses
(function () {
	if (document.getElementById("kh-float-btn")) return;

	var style = document.createElement("style");
	style.textContent =
		"#kh-float-btn {" +
			"display: none; position: fixed; bottom: 20px; right: 20px;" +
			"width: 44px; height: 44px; border-radius: 50%;" +
			"background: var(--primary, #171717); color: #fff;" +
			"font-size: 20px; font-weight: 700; line-height: 44px; text-align: center;" +
			"text-decoration: none; box-shadow: 0 2px 8px rgba(0,0,0,0.2);" +
			"z-index: 1040; transition: transform 0.15s ease;" +
		"}" +
		"#kh-float-btn:hover { transform: scale(1.1); color: #fff; text-decoration: none; }" +
		"@media (max-width: 991.98px) { #kh-float-btn { display: block; } }";
	document.head.appendChild(style);

	var btn = document.createElement("a");
	btn.id = "kh-float-btn";
	btn.href = "/help";
	btn.textContent = "?";
	btn.setAttribute("aria-label", "Help");
	document.body.appendChild(btn);
})();
